function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.65 6.56L4.2 20.01c-1.4-.89-1.95-2.48-1.95-4.01V8c0-3.42 1.33-4.75 4.75-4.75h6c2.89 0 4.29.95 4.65 3.31zm.1 2.69V16c0 .08-.01.14-.01.21 0 .07-.01.14-.01.21h.01c-.11 3.11-1.46 4.33-4.74 4.33H7c-.25 0-.48-.01-.71-.04L17.75 9.25z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M17.73 16.42c0-.07.01-.14.01-.21.01.07.01.14 0 .21h-.01zm.01-8.85c.01.07.01.15 0 .22 0-.07-.01-.14-.01-.21l.01-.01z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.75 8.38v7.24c0 1.43-.69 2-1.1 2.21-.19.1-.48.21-.85.21-.43 0-.97-.14-1.59-.58l-1.47-1.04h-.01c0-.07.01-.14.01-.21 0-.07.01-.13.01-.21V9.25l3.27-3.27c.27.02.48.1.63.19.41.21 1.1.78 1.1 2.21zm-.98-6.15c-.3-.3-.79-.3-1.09 0L2.23 20.69c-.3.3-.3.79 0 1.09a.758.758 0 001.08-.01L21.77 3.31c.31-.3.31-.78 0-1.08z"
})));